export default {
      id: "logo_footer-usage",
      viewBox: "0 0 231 140",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#logo_footer-usage",
      toString: function () {
        return this.url;
      }
    }